import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_playerIdAdapter2h87xjwribaa as get_playerIdAdapter } from '../../../adapter/Adapter.mjs';
import {
  get_StringAdapter1plpsgiy8rwhj as get_StringAdapter,
  nullable1in0t8o94jx9t as nullable,
  presentmhd0a0ip21um as present,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  list2lpjhmv1d2k19 as list,
  obj2vqjd1bjrpmyg as obj,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Badge_ResponseAdapter_instance1qq3nwu3zphmj as Badge_ResponseAdapter_instance } from './Badge_ResponseAdapter.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { AvatarType_ResponseAdapter_instance3r68caydq4mko as AvatarType_ResponseAdapter_instance } from './AvatarType_ResponseAdapter.mjs';
import { PinInput_InputAdapter_instance1f6yngk98x7z6 as PinInput_InputAdapter_instance } from './PinInput_InputAdapter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PinnedPlayerInput1hnlnl1bk4or8 as PinnedPlayerInput } from '../PinnedPlayerInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PinnedPlayerInput_InputAdapterClass;
function PinnedPlayerInput_InputAdapter() {
  if (PinnedPlayerInput_InputAdapterClass === VOID) {
    class $ {
      t3x(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      l6t(writer, customScalarAdapters, value) {
        writer.o4a('id');
        get_playerIdAdapter().u3x(writer, customScalarAdapters, value.u6q_1);
        writer.o4a('name');
        get_StringAdapter().u3x(writer, customScalarAdapters, value.v6q_1);
        writer.o4a('email');
        get_StringAdapter().u3x(writer, customScalarAdapters, value.w6q_1);
        var tmp = value.x6q_1;
        if (tmp instanceof Present()) {
          writer.o4a('badge');
          present(nullable(Badge_ResponseAdapter_instance)).s3y(writer, customScalarAdapters, value.x6q_1);
        }
        writer.o4a('callSignAdjective');
        get_StringAdapter().u3x(writer, customScalarAdapters, value.y6q_1);
        writer.o4a('callSignNoun');
        get_StringAdapter().u3x(writer, customScalarAdapters, value.z6q_1);
        var tmp_0 = value.a6r_1;
        if (tmp_0 instanceof Present()) {
          writer.o4a('imageURL');
          present(get_NullableStringAdapter()).s3y(writer, customScalarAdapters, value.a6r_1);
        }
        var tmp_1 = value.b6r_1;
        if (tmp_1 instanceof Present()) {
          writer.o4a('avatarType');
          present(nullable(AvatarType_ResponseAdapter_instance)).s3y(writer, customScalarAdapters, value.b6r_1);
        }
        writer.o4a('unvalidatedEmails');
        list(get_StringAdapter()).q3y(writer, customScalarAdapters, value.c6r_1);
        writer.o4a('pins');
        list(obj(PinInput_InputAdapter_instance)).q3y(writer, customScalarAdapters, value.d6r_1);
      }
      u3x(writer, customScalarAdapters, value) {
        return this.l6t(writer, customScalarAdapters, value instanceof PinnedPlayerInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'PinnedPlayerInput_InputAdapter', VOID, VOID, [Adapter()]);
    PinnedPlayerInput_InputAdapterClass = $;
  }
  return PinnedPlayerInput_InputAdapterClass;
}
var PinnedPlayerInput_InputAdapter_instance;
function PinnedPlayerInput_InputAdapter_getInstance() {
  return PinnedPlayerInput_InputAdapter_instance;
}
//region block: init
PinnedPlayerInput_InputAdapter_instance = new (PinnedPlayerInput_InputAdapter())();
//endregion
//region block: exports
export {
  PinnedPlayerInput_InputAdapter_instance as PinnedPlayerInput_InputAdapter_instance2asphtnknnzjz,
};
//endregion

//# sourceMappingURL=PinnedPlayerInput_InputAdapter.mjs.map
